import loginPortalAcesso from '@/App/(unauthenticated)/seguranca/login-portal-acesso/login-portal-acesso.vue'
import SelecionarPerfil from '@/screens/portal/seguranca/SelecionarPerfil'
import AdministradorAcesso from '@/screens/portal/seguranca/AdministradorAcesso.vue'
import CadastroUsuario from '@/screens/portal/seguranca/CadastroUsuario.vue'
import SelecionarModuloInicial from '@/App/(authenticated)/selecionar-modulo/selecionar-modulo.vue'
import Termos from '@/App/(authenticated)/termos/termos.vue'
import PoliticaDePrivacidade from '@/App/(authenticated)/termos/politica-de-privacidade/politica-de-privacidade.vue'
import TermoDeUso from '@/App/(authenticated)/termos/termo-de-uso/termo-de-uso.vue'
import cadastroSenha from '@/App/(unauthenticated)/seguranca/cadastro-senha/cadastro-senha.vue'
import store from '@/store'

const beforeEnter = async (to, from, next) => {
  const usuario = await store.dispatch('auth/getUsuario')

  if (usuario) {
    next('/selecionarModulo')
  } else {
    next()
  }
}

export const items = [
  {
    path: '/login',
    name: 'login',
    component: loginPortalAcesso,
    meta: { isPublic: true },
    beforeEnter: beforeEnter
  },
  {
    path: '/selecionarModulo',
    name: 'selecionarModulo',
    component: SelecionarModuloInicial
  },
  {
    path: '/selecionarPerfil',
    name: 'selecionarPerfil',
    component: SelecionarPerfil
  },
  {
    path: '/administradorAcesso',
    name: 'portalSeguranca/administradorAcesso',
    component: AdministradorAcesso
  },
  {
    path: '/cadastroUsuario/:tipo',
    name: 'cadastroUsuario',
    component: CadastroUsuario,
    meta: { isPublic: true }
  },
  {
    path: '/editarUsuario/:cpfCnpj',
    name: 'editarUsuario',
    component: CadastroUsuario
  },
  {
    path: '/cadastrarSenha/:codigo',
    name: 'cadastrarSenha',
    component: cadastroSenha,
    meta: { isPublic: true }
  },
  {
    path: '/termos',
    name: 'termos',
    component: Termos
  },
  {
    path: '/termo-de-uso',
    name: 'termoDeUso',
    component: TermoDeUso,
    meta: { isPublic: true }
  },
  {
    path: '/aviso-de-privacidade',
    name: 'avisoDePrivacidade',
    component: PoliticaDePrivacidade,
    meta: { isPublic: true }
  }
]



// WEBPACK FOOTER //
// ./src/router/seguranca/routes.js